import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/app/not-found.tsx");
